






























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NavbarComponent from '@/components/NavbarComponent.vue'; // @ is an alias to /src
import AlertComponentBottom from '@/components/AlertComponentBottom.vue'; // @ is an alias to /src
import AlertComponentTop from '@/components/AlertComponentTop.vue'; // @ is an alias to /src
const ModalWrapperComponent = () => import('@/components/ModalWrapperComponent.vue')
import * as utils from '@/utils'
import * as utils_tracker from '@/utils_tracker'
import { TokenUser } from '@/TokenUser';
import CookieLaw from 'vue-cookie-law'

@Component({
  name: 'App',
  components: {
    NavbarComponent,
    AlertComponentBottom,
    AlertComponentTop,
    ModalWrapperComponent,
    CookieLaw
  },
})
export default class App extends Vue {
  // public reactive member variables available to the html template
  public MAINTENANCE: boolean = false

  // public functions available to the html template
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): TokenUser { return this.$store.getters.userObject }
  public get userId(): string { return this.$store.getters.userId }

  public get supportEmail(): string { return 'bonfire@livetoken.co'}

  public clickedFAQ() {
    (this.$refs.FAQComponent as any).show(`Frequently Asked Questions`, 'lg', null)
  }

  public async clickedPrivacyPolicy() {
    try { 
      await this.$router.push({ name: 'privacyPolicy'})
    } catch (Error) {}
  }

  public async clickedTOS() {
    try { 
      await this.$router.push({ name: 'tos'})
    } catch (Error) {}
  }

  public acceptedCookieLaw() {
    // use nextTick to avoid utils_tracker have vue not set problems
    // disabled because happened every time even after having acceptedCookieLaw
    /*
    this.$nextTick(() => {
      utils_tracker.track('User AcceptedCookieLaw', null)
    });
    */
  }

  // private functions not available directly to HTML template
  private async created() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} created()`)

    // store utm parameters into localStorage so that we always know them
    utils.saveUTMsToLocalStorage(this.$route.query)

    // sync clocks
    await utils.setMsTimeServerIsAhead(this)

    // set/get uniqueClientID
    const ucid: number = utils.getAndSetUniqueClientID()

    // lucky orange done only for 1/20 "lucky" people because of too much traffic
    // April 22, 2024 -- removed lucky orange because Microsoft Clarity is free
    /*
    if (ucid % 20 === 0) {
      // @ts-ignore
      window.__lo_site_id = 288592
      const luckyOrangeScript = document.createElement('script')
      luckyOrangeScript.setAttribute('src', 'https://d10lpsik1i8c69.cloudfront.net/w.js')
      document.head.appendChild(luckyOrangeScript)
    }
    */
    
  }

  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)
  }

}
